export enum ExpenseClassification
{
    None = 'None',
    OpEx = 'OpEx',
    COGS = 'COGS',
}

export enum DepreciationMethodType
{
    None = 'None',
    Immediate = 'Immediate',   
    StraightLine = 'StraightLine',
}